import fetch from '../../../../core/fetch';
import showToaster from '../../../../helpers/toasterMessages/showToaster';

async function submit(values, dispatch) {
  const query = `
  mutation (
    $hostBannerTitle1: String,
    $hostBannerTitle1_en: String,
    $hostBannerTitle1_fr: String,
    $hostBannerTitle1_it: String,
    $hostBannerTitle1_pt: String,
    $hostBannerContent1: String,
    $hostBannerContent1_en: String,
    $hostBannerContent1_fr: String,
    $hostBannerContent1_it: String,
    $hostBannerContent1_pt: String,
    $hostBannerImage1: String,
    $hostBannerImage2: String,
    $hostBannerContent2: String,
    $hostBannerContent2_en: String,
    $hostBannerContent2_fr: String,
    $hostBannerContent2_it: String,
    $hostBannerContent2_pt: String,
    $buttonLabel: String,
    $buttonLabel_en: String,
    $buttonLabel_fr: String,
    $buttonLabel_it: String,
    $buttonLabel_pt: String,
    $buttonLabel2: String,
    $buttonLabel2_en: String,
    $buttonLabel2_fr: String,
    $buttonLabel2_it: String,
    $buttonLabel2_pt: String
) {
  updateWhyHostPage (
    hostBannerTitle1: $hostBannerTitle1,
    hostBannerTitle1_en: $hostBannerTitle1_en,
    hostBannerTitle1_fr: $hostBannerTitle1_fr,
    hostBannerTitle1_it: $hostBannerTitle1_it,
    hostBannerTitle1_pt: $hostBannerTitle1_pt,
    hostBannerContent1: $hostBannerContent1,
    hostBannerContent1_en: $hostBannerContent1_en,
    hostBannerContent1_fr: $hostBannerContent1_fr,
    hostBannerContent1_it: $hostBannerContent1_it,
    hostBannerContent1_pt: $hostBannerContent1_pt,
    hostBannerImage1: $hostBannerImage1,
    hostBannerImage2: $hostBannerImage2,
    hostBannerContent2: $hostBannerContent2,
    hostBannerContent2_en: $hostBannerContent2_en,
    hostBannerContent2_fr: $hostBannerContent2_fr,
    hostBannerContent2_it: $hostBannerContent2_it,
    hostBannerContent2_pt: $hostBannerContent2_pt,
    buttonLabel: $buttonLabel,
    buttonLabel_en: $buttonLabel_en,
    buttonLabel_fr: $buttonLabel_fr,
    buttonLabel_it: $buttonLabel_it,
    buttonLabel_pt: $buttonLabel_pt,
    buttonLabel2: $buttonLabel2,
    buttonLabel2_en: $buttonLabel2_en,
    buttonLabel2_fr: $buttonLabel2_fr,
    buttonLabel2_it: $buttonLabel2_it,
    buttonLabel2_pt: $buttonLabel2_pt
  ) {
      status
  }
}

  `;

  const resp = await fetch('/graphql', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      query: query,
      variables: values
    }),
    credentials: 'include',
  });

  const { data } = await resp.json();

  if (data?.updateWhyHostPage?.status === "success") {
    showToaster({ messageId: 'updateWhyHostPage', toasterType: 'success' })
  } else {
    showToaster({ messageId: 'updateWhyHostPageFailed', toasterType: 'error' })
  }

}

export default submit;
